var _rect, _rect2, _rect3, _g, _rect4, _rect5, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19491_32681)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74.9737,
    fill: "url(#paint0_linear_19491_32681)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19491_32681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 106
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 105.158,
    rx: 12,
    fill: "url(#paint1_linear_19491_32681)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 104.158,
    rx: 11.5,
    stroke: "url(#paint2_linear_19491_32681)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19491_32681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1552 163.563C114.546 146.595 133.651 99.5397 115.902 58.4922C98.1533 17.4446 50.2353 -2.13539 8.84439 14.8324C-32.5465 31.8001 -51.6515 78.8556 -33.9026 119.903C-16.1537 160.951 31.7643 180.531 73.1552 163.563Z",
    stroke: "#F1847E",
    strokeOpacity: 0.13,
    strokeWidth: 46,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.147 54.7023C145.105 100.858 123.609 153.718 77.1361 172.769C30.6629 191.821 -23.19 169.848 -43.1475 123.693C-63.1051 77.5375 -41.6096 24.6771 4.8636 5.62588C51.3368 -13.4253 105.19 8.54676 125.147 54.7023Z",
    stroke: "url(#paint3_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.323 57.915C135.425 99.7793 115.928 147.725 73.7758 165.005C31.6234 182.285 -17.2226 162.356 -35.3246 120.491C-53.4267 78.6271 -33.9297 30.6814 8.22273 13.4014C50.3752 -3.87856 99.2212 16.0507 117.323 57.915Z",
    stroke: "url(#paint4_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.172 60.8496C126.578 98.7911 108.908 142.244 70.7054 157.905C32.5027 173.566 -11.7664 155.504 -28.1722 117.562C-44.5781 79.6209 -26.908 36.1678 11.2947 20.507C49.4974 4.84617 93.7665 22.908 110.172 60.8496Z",
    stroke: "url(#paint5_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.35 64.0605C116.9 97.7113 101.228 136.25 67.3458 150.14C33.4634 164.03 -5.79933 148.011 -20.3499 114.36C-34.9004 80.709 -19.2286 42.1699 14.6538 28.2802C48.5362 14.3904 87.799 30.4097 102.35 64.0605Z",
    stroke: "url(#paint6_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7036 70.4754C97.5433 95.5442 85.8682 124.255 60.6269 134.602C35.3856 144.95 6.13604 133.016 -4.70369 107.947C-15.5434 82.878 -3.86837 54.1675 21.3729 43.8201C46.6143 33.4727 75.8638 45.4065 86.7036 70.4754Z",
    stroke: "url(#paint7_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8784 73.6842C87.8626 94.4618 78.1861 118.258 57.2656 126.834C36.3451 135.41 12.1024 125.519 3.11823 104.741C-5.86598 83.9637 3.81057 60.1678 24.7311 51.5917C45.6516 43.0156 69.8942 52.9065 78.8784 73.6842Z",
    stroke: "url(#paint8_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0566 76.8931C78.1855 93.38 70.5072 112.262 53.907 119.067C37.3068 125.872 18.0704 118.024 10.9415 101.537C3.81262 85.0498 11.4909 66.168 28.0911 59.3629C44.6913 52.5578 63.9277 60.4062 71.0566 76.8931Z",
    stroke: "url(#paint9_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2325 80.101C68.5059 92.2966 62.8261 106.264 50.5467 111.298C38.2673 116.331 24.0378 110.526 18.7644 98.3302C13.491 86.1345 19.1708 72.1674 31.4502 67.1336C43.7297 62.0998 57.9591 67.9053 63.2325 80.101Z",
    stroke: "url(#paint10_linear_19491_32681)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4097 83.308C58.8278 91.2129 55.1462 100.266 47.1871 103.529C39.228 106.792 30.0048 103.029 26.5867 95.1237C23.1687 87.2187 26.8502 78.1656 34.8093 74.9029C42.7684 71.6401 51.9916 75.4031 55.4097 83.308Z",
    stroke: "url(#paint11_linear_19491_32681)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19491_32681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    rx: 12,
    fill: "#F4F4F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 73,
    rx: 11.5,
    stroke: "url(#paint12_linear_19491_32681)",
    strokeOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19491_32681)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.488 45.0679L308.472 45.0987L308.459 45.1305C307.644 47.085 306.867 48.9454 305.788 50.64L305.772 50.6651L305.758 50.6912C304.935 52.1718 303.79 54.463 303.13 55.9472L303.126 55.9555L303.123 55.9639L294.713 75.8565C294.712 75.8575 294.712 75.8586 294.711 75.8596C294.161 77.1455 293.985 78.4179 293.985 79.6474V93.8533H259.264V84.1768C259.264 81.6834 257.361 79.7798 254.867 79.7798H248.235C245.39 79.7798 243.088 77.4775 243.088 74.6327V64.118C243.088 61.6246 241.184 59.721 238.691 59.721H232.311L232.305 59.7147L232.306 59.7123L239.909 44.5064C241.269 41.7868 241.976 38.8405 241.625 35.8541L241.624 35.8418L241.622 35.8295C241.472 34.7791 241.47 33.7177 241.47 32.5739C241.47 12.6041 258.609 -4.06279 279.843 -2.0191C286.129 -1.39018 292.103 0.967419 297.135 4.74156L297.157 4.75821L297.18 4.7736C297.619 5.06588 298.185 5.20851 298.737 5.13499C299.303 5.05946 299.883 4.74521 300.219 4.12004C300.755 3.25913 300.743 1.87375 299.629 1.03858L299.621 1.03296C293.978 -3.11658 287.18 -5.76747 280.056 -6.59587L280.056 -6.59593L280.045 -6.5971C256.298 -9.08803 236.882 9.68142 236.882 32.4121V32.4474C236.882 33.5457 236.882 34.882 237.049 36.0758C237.19 38.1443 236.745 40.3834 235.848 42.3321L228.252 57.5238C226.658 60.7129 228.818 64.3092 232.058 64.3092H238.478C238.481 64.3122 238.485 64.3157 238.489 64.3196C238.493 64.3235 238.497 64.3274 238.5 64.3311V74.7945C238.5 80.038 242.83 84.368 248.073 84.368H254.654C254.658 84.371 254.662 84.3745 254.666 84.3784C254.669 84.3816 254.672 84.3848 254.674 84.3878C254.675 84.3885 254.675 84.3893 254.676 84.39V96.1474C254.676 97.2631 255.529 98.4416 256.97 98.4416H296.117C297.233 98.4416 298.411 97.5887 298.411 96.1474V79.8092C298.411 79.1399 298.544 78.4597 298.822 77.7629L307.226 57.8833C307.283 57.7557 307.341 57.6238 307.401 57.4886C308.053 56.016 308.878 54.1522 309.549 53.214L309.575 53.1764L309.599 53.1366C310.756 51.1523 311.744 49.0129 312.565 46.8825C313.087 45.7654 312.592 44.2353 311.242 43.8979C310.774 43.7808 310.243 43.7644 309.733 43.9465C309.203 44.1357 308.763 44.5175 308.488 45.0679Z",
    fill: "url(#paint13_linear_19491_32681)",
    stroke: "url(#paint14_linear_19491_32681)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.838 32.6033H314.444C313.792 33.4846 313.864 34.7492 314.661 35.5457C315.537 36.4215 316.979 36.4215 317.854 35.5457L323.516 29.8839L323.516 29.884L323.525 29.8744C329.884 23.3444 329.897 13.0124 323.516 6.63147C317.14 0.255655 306.801 0.255655 300.425 6.63147C299.883 7.17361 299.335 7.79071 298.827 8.48336C298.412 7.95347 297.971 7.45419 297.472 6.955C291.258 0.740949 281.081 0.740949 274.867 6.955C268.653 13.1691 268.653 23.3463 274.867 29.5604L297.837 52.531C298.174 52.8677 298.747 53.1474 299.353 53.1474C299.959 53.1474 300.532 52.8677 300.869 52.531L300.162 51.8239L300.869 52.531L308.957 44.4427C309.833 43.5669 309.833 42.1249 308.957 41.2491C308.081 40.3733 306.639 40.3733 305.764 41.2491L299.191 47.8214L283.164 31.7945H285.765C286.458 31.7945 287.197 31.5498 287.596 30.821L290.021 27.1838L293.555 37.1068C293.803 37.8406 294.416 38.5886 295.471 38.5886H295.633C295.974 38.5886 296.387 38.5338 296.769 38.295C297.131 38.0689 297.365 37.7414 297.507 37.3801L305.934 23.6692L308.765 31.1331C309.077 32.0351 309.953 32.6033 310.838 32.6033ZM320.675 26.6614L318.884 28.1768H312.503L308.707 18.0037C308.457 17.2724 307.846 16.5298 306.794 16.5298C306.195 16.5298 305.168 16.7288 304.759 17.7355L296.37 31.3853L293.02 21.7364C292.773 21.0013 292.16 20.2503 291.103 20.2503C290.759 20.2503 290.386 20.3064 290.044 20.4432C289.731 20.5685 289.348 20.8023 289.113 21.22L284.906 27.5298H279.061L278.06 26.5285C273.598 22.0661 273.598 14.611 278.06 10.1486C282.523 5.68621 289.978 5.68621 294.44 10.1486C295.47 11.1783 296.366 12.515 296.967 13.8555C297.288 14.7393 298.154 15.2945 299.03 15.2945C299.912 15.2945 300.784 14.7306 301.099 13.8346C301.694 12.3579 302.584 11.0223 303.781 9.8251C308.405 5.20092 316.022 5.20092 320.646 9.8251C325.261 14.4397 325.27 22.0345 320.675 26.6614Z",
    fill: "url(#paint15_linear_19491_32681)",
    stroke: "url(#paint16_linear_19491_32681)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.347 102.251C254.84 101.094 254.71 99.7981 254.968 98.4622C255.828 94.3882 261.386 90.1378 266.27 87.2424C269.783 85.1322 273.43 83.1897 277.183 81.4292C284.091 78.0764 291.231 75.1492 298.522 72.6814C302.439 71.3002 306.414 70.1182 310.419 69.144C315.959 67.7659 322.897 66.7081 326.56 69.1139C328.908 70.6587 329.977 73.1315 329.471 75.8467C328.678 80.0788 323.053 84.1711 318.155 87.0348C314.657 89.1668 311.013 91.1206 307.256 92.8797C301.628 95.596 295.85 98.0392 289.963 100.192C288.627 100.74 287.335 101.269 285.916 101.628C282.014 103.011 278.047 104.177 274.05 105.115C268.479 106.543 261.586 107.583 257.879 105.195C256.716 104.427 255.851 103.422 255.347 102.251Z",
    stroke: "#F1847E",
    strokeOpacity: 0.13,
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.101 118.511L215.1 118.511C214.093 116.217 213.861 113.636 214.425 110.961C215.361 106.884 218.706 102.675 223.1 98.7356C227.491 94.7989 232.916 91.1434 237.988 88.1717L237.988 88.1714C245.287 83.8397 252.856 79.8417 260.64 76.207L260.641 76.2065C274.974 69.2894 289.774 63.2222 304.871 58.0748L304.873 58.0743C312.984 55.1981 321.21 52.7207 329.492 50.6603L329.493 50.6602C335.221 49.2046 341.664 47.9022 347.607 47.5559C353.554 47.2093 358.983 47.8215 362.699 50.1763C367.465 53.2009 369.586 58.1055 368.477 63.5388C367.61 67.7724 364.266 71.9809 359.851 75.8727C355.44 79.7618 349.974 83.3225 344.888 86.263L344.886 86.2639C337.618 90.6388 330.055 94.6593 322.262 98.2912L322.261 98.2916C310.585 103.896 298.607 108.956 286.413 113.434L286.413 113.434L286.41 113.435C283.638 114.571 280.966 115.667 278.038 116.421L278.038 116.421L278.03 116.424C269.948 119.305 261.739 121.75 253.476 123.737L253.474 123.737C247.713 125.243 241.278 126.561 235.338 126.916C229.395 127.27 223.966 126.658 220.203 124.322C217.841 122.818 216.099 120.832 215.101 118.511Z",
    stroke: "url(#paint17_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.051 116.073L221.051 116.072C220.133 113.982 219.929 111.627 220.458 109.183C221.333 105.457 224.427 101.602 228.486 97.9873C232.543 94.3757 237.551 91.0173 242.231 88.2846L242.231 88.2844C248.966 84.3015 255.949 80.6224 263.129 77.2746L263.13 77.2741C276.35 70.9045 289.998 65.3098 303.916 60.5543L303.917 60.5539C311.395 57.8978 318.977 55.6058 326.609 53.6945L326.61 53.6944C331.889 52.3445 337.824 51.1323 343.296 50.7951C348.773 50.4577 353.766 50.9982 357.176 53.1352C361.55 55.8798 363.482 60.3493 362.442 65.3134C361.629 69.1816 358.536 73.0369 354.458 76.6078C350.383 80.176 345.338 83.4479 340.645 86.1521L340.643 86.153C333.936 90.1753 326.959 93.8748 319.771 97.22L319.77 97.2205C309 102.382 297.954 107.046 286.712 111.18L286.712 111.18L286.709 111.181C284.153 112.229 281.689 113.239 278.992 113.938L278.991 113.938L278.983 113.941C271.532 116.601 263.966 118.863 256.352 120.707L256.35 120.708C251.041 122.104 245.112 123.331 239.643 123.675C234.17 124.019 229.177 123.479 225.724 121.359C223.555 119.994 221.961 118.188 221.051 116.073Z",
    stroke: "url(#paint18_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.758 113.734L226.757 113.734C225.924 111.836 225.745 109.693 226.239 107.467C227.055 104.074 229.906 100.553 233.643 97.2481C237.378 93.9454 241.985 90.87 246.288 88.3655L246.289 88.3652C252.483 84.7151 258.903 81.3407 265.503 78.2674L265.504 78.2669C277.657 72.4209 290.2 67.2793 302.987 62.9009L302.989 62.9005C309.859 60.4561 316.825 58.3429 323.834 56.5763L323.835 56.5761C328.684 55.3288 334.134 54.2047 339.155 53.879C344.181 53.5531 348.759 54.0285 351.878 55.9615C355.877 58.4441 357.633 62.5038 356.661 67.0243C355.902 70.5472 353.052 74.0675 349.297 77.3333C345.546 80.5965 340.905 83.5932 336.589 86.0719L336.588 86.0728C330.419 89.7588 324.004 93.1517 317.397 96.2227L317.396 96.2232C307.495 100.96 297.343 105.246 287.013 109.049L287.013 109.049L287.01 109.05C284.661 110.013 282.397 110.941 279.92 111.587L279.92 111.587L279.911 111.59C273.065 114.038 266.115 116.124 259.122 117.829L259.12 117.83C254.244 119.119 248.8 120.256 243.781 120.589C238.758 120.921 234.18 120.446 231.022 118.528C229.039 117.294 227.584 115.655 226.758 113.734Z",
    stroke: "url(#paint19_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.464 111.398L232.464 111.397C231.721 109.705 231.573 107.79 232.037 105.794C232.801 102.752 235.415 99.5806 238.836 96.595C242.254 93.6122 246.462 90.827 250.392 88.5551L250.392 88.5549C256.048 85.2442 261.908 82.1791 267.928 79.3825L267.929 79.382C279.018 74.0651 290.455 69.3765 302.11 65.3701L302.111 65.3697C308.374 63.1348 314.72 61.1959 321.104 59.5672L321.105 59.5671C325.521 58.4179 330.482 57.3751 335.049 57.0503C339.62 56.7253 343.776 57.1215 346.595 58.831C350.209 61.0262 351.774 64.6462 350.861 68.6976C350.147 71.8555 347.534 75.0264 344.098 77.9767C340.665 80.9243 336.427 83.6392 332.486 85.8881L332.485 85.8889C326.852 89.2315 320.997 92.3132 314.97 95.1077L314.969 95.1082C305.936 99.4172 296.677 103.323 287.26 106.798L287.26 106.798L287.257 106.799C285.115 107.677 283.051 108.523 280.795 109.118L280.795 109.118L280.787 109.121C274.547 111.359 268.214 113.273 261.846 114.847L261.844 114.847C257.402 116.034 252.446 117.089 247.882 117.419C243.314 117.75 239.158 117.354 236.303 115.659C234.511 114.567 233.201 113.111 232.464 111.398Z",
    stroke: "url(#paint20_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.908 108.758L238.907 108.757C238.246 107.252 238.115 105.548 238.527 103.772C239.208 101.065 241.534 98.2416 244.582 95.582C247.626 92.9251 251.374 90.4442 254.875 88.4203L254.875 88.42C259.914 85.4706 265.134 82.7401 270.498 80.2487L270.499 80.2481C280.377 75.5114 290.567 71.3344 300.95 67.7651L300.951 67.7647C306.53 65.7737 312.184 64.0464 317.871 62.5954L317.872 62.5953C321.806 61.5715 326.226 60.6426 330.293 60.3534C334.365 60.0639 338.065 60.4171 340.573 61.9382C343.789 63.8915 345.182 67.112 344.369 70.7169C343.733 73.5269 341.407 76.35 338.347 78.9781C335.29 81.6036 331.514 84.022 328.004 86.0254L328.002 86.0262C322.984 89.004 317.768 91.7494 312.398 94.239L312.397 94.2394C304.35 98.0782 296.102 101.558 287.712 104.653L287.712 104.653L287.709 104.655C285.8 105.437 283.962 106.191 281.953 106.72L281.953 106.72L281.945 106.723C276.386 108.717 270.745 110.422 265.071 111.824L265.069 111.825C261.113 112.882 256.697 113.822 252.632 114.116C248.563 114.411 244.864 114.058 242.323 112.549C240.728 111.577 239.563 110.282 238.908 108.758Z",
    stroke: "url(#paint21_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.615 106.424L244.614 106.423C244.026 105.083 243.909 103.567 244.276 101.985C244.882 99.5751 246.954 97.0595 249.671 94.6886C252.384 92.3205 255.726 90.1089 258.846 88.3047L258.847 88.3044C263.339 85.675 267.993 83.2406 272.774 81.0195L272.776 81.019C281.582 76.796 290.667 73.072 299.924 69.89L299.925 69.8896C304.899 68.1145 309.939 66.5746 315.01 65.2811L315.01 65.2809C318.517 64.3682 322.457 63.5402 326.083 63.2824C329.713 63.0243 333.008 63.3395 335.241 64.6938C338.105 66.4329 339.344 69.2995 338.62 72.509C338.054 75.0108 335.983 77.526 333.255 79.8688C330.53 82.2089 327.164 84.3647 324.035 86.1508L324.033 86.1516C319.559 88.8064 314.909 91.2539 310.122 93.4734L310.121 93.4738C302.947 96.8963 295.593 99.9985 288.114 102.758L288.114 102.758L288.11 102.76C286.409 103.457 284.77 104.129 282.98 104.601L282.98 104.6L282.972 104.603C278.016 106.381 272.987 107.901 267.928 109.151L267.927 109.152C264.399 110.095 260.464 110.932 256.84 111.194C253.213 111.457 249.917 111.142 247.655 109.799C246.235 108.933 245.198 107.78 244.615 106.424Z",
    stroke: "url(#paint22_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.586 104.385L249.585 104.385C249.06 103.189 248.955 101.836 249.283 100.424C249.824 98.272 251.675 96.0247 254.103 93.9052C256.529 91.7885 259.516 89.8115 262.306 88.1986L262.306 88.1983C266.322 85.8476 270.483 83.6713 274.757 81.6855L274.759 81.685C282.632 77.9095 290.754 74.5801 299.03 71.7352L299.031 71.7348C303.478 70.1479 307.984 68.7712 312.517 67.6148L312.518 67.6146C315.653 66.7987 319.175 66.0586 322.416 65.8282C325.66 65.5974 328.604 65.8794 330.597 67.0885C333.154 68.6409 334.26 71.1993 333.614 74.0646C333.109 76.298 331.259 78.5448 328.82 80.6392C326.384 82.7309 323.376 84.6579 320.578 86.2546L320.577 86.2555C316.577 88.6288 312.419 90.817 308.14 92.8012L308.139 92.8017C301.725 95.8615 295.151 98.635 288.464 101.102L288.464 101.102L288.46 101.104C286.939 101.727 285.474 102.327 283.875 102.749L283.875 102.749L283.866 102.752C279.436 104.341 274.939 105.7 270.417 106.818L270.416 106.818C267.262 107.661 263.744 108.41 260.505 108.644C257.263 108.879 254.319 108.597 252.3 107.398C251.032 106.625 250.106 105.596 249.586 104.385Z",
    stroke: "url(#paint23_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.821 102.648L253.821 102.648C253.35 101.575 253.256 100.36 253.55 99.0929C254.036 97.1615 255.697 95.1427 257.88 93.2375C260.06 91.3351 262.745 89.5581 265.253 88.1082L265.253 88.1079C268.863 85.9946 272.604 84.0381 276.447 82.253L276.448 82.2525C283.526 78.8583 290.828 75.8652 298.268 73.3076L298.269 73.3072C302.267 71.8806 306.318 70.643 310.393 69.6034L310.393 69.6033C313.212 68.8697 316.378 68.2045 319.29 67.9974C322.207 67.79 324.85 68.0438 326.64 69.129C328.934 70.5225 329.927 72.8183 329.347 75.39C328.894 77.3947 327.233 79.413 325.04 81.2957C322.851 83.1755 320.147 84.9077 317.632 86.3431L317.631 86.3439C314.035 88.4775 310.298 90.4446 306.451 92.2284L306.45 92.2288C300.683 94.9796 294.773 97.473 288.761 99.6911L288.761 99.691L288.758 99.6924C287.39 100.253 286.074 100.792 284.637 101.172L284.636 101.171L284.628 101.174C280.645 102.603 276.603 103.825 272.538 104.829L272.536 104.83C269.701 105.587 266.539 106.26 263.628 106.471C260.714 106.682 258.07 106.428 256.257 105.352C255.119 104.658 254.288 103.734 253.821 102.648Z",
    stroke: "url(#paint24_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.793 100.61L258.793 100.609C258.385 99.6809 258.303 98.6291 258.558 97.5311C258.979 95.8583 260.419 94.1078 262.314 92.4541C264.205 90.8031 266.536 89.2608 268.713 88.0022L268.713 88.0019C271.847 86.1674 275.094 84.469 278.43 82.9193L278.431 82.9188C284.576 79.9722 290.915 77.3737 297.374 75.1534L297.375 75.153C300.846 73.9146 304.362 72.8402 307.9 71.9377L307.9 71.9375C310.347 71.3008 313.095 70.7235 315.622 70.5438C318.154 70.3637 320.445 70.5844 321.995 71.5243C323.983 72.7311 324.842 74.7186 324.34 76.946C323.947 78.6823 322.508 80.4322 320.605 82.0664C318.705 83.6977 316.358 85.2011 314.175 86.4471L314.173 86.448C311.052 88.3001 307.808 90.0077 304.468 91.5562L304.467 91.5567C299.461 93.9447 294.33 96.1093 289.111 98.035L289.111 98.0349L289.108 98.0363C287.92 98.5233 286.778 98.9911 285.531 99.32L285.531 99.3197L285.523 99.3226C282.065 100.563 278.556 101.624 275.027 102.496L275.025 102.496C272.565 103.154 269.82 103.738 267.294 103.92C264.764 104.104 262.473 103.883 260.902 102.951C259.916 102.35 259.197 101.55 258.793 100.61Z",
    stroke: "url(#paint25_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M263.765 98.5721L263.764 98.5713C263.42 97.7874 263.351 96.8987 263.566 95.9701C263.922 94.5559 265.141 93.0738 266.747 91.6716C268.351 90.2722 270.326 88.9646 272.172 87.8973L272.173 87.897C274.83 86.3413 277.584 84.9009 280.413 83.5867L280.414 83.5862C285.626 81.0872 291.002 78.8835 296.48 77.0004L296.481 77C299.424 75.9497 302.406 75.0386 305.406 74.2733L305.407 74.2731C307.482 73.7331 309.811 73.2437 311.953 73.0914C314.1 72.9388 316.04 73.1262 317.35 73.9209C319.03 74.9411 319.756 76.6202 319.331 78.5031C318.999 79.9709 317.782 81.4526 316.168 82.8382C314.558 84.221 312.568 85.4956 310.717 86.5522L310.715 86.553C308.068 88.1237 305.317 89.5719 302.485 90.885L302.484 90.8855C298.238 92.9108 293.886 94.7466 289.46 96.3798L289.46 96.3797L289.457 96.381C288.449 96.7942 287.482 97.1905 286.425 97.4692L286.425 97.4689L286.417 97.4718C283.485 98.5236 280.509 99.4231 277.516 100.163L277.516 100.163L277.515 100.163C275.428 100.721 273.101 101.216 270.96 101.371C268.815 101.526 266.875 101.339 265.548 100.551C264.714 100.042 264.106 99.366 263.765 98.5721Z",
    stroke: "url(#paint26_linear_19491_32681)",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.011 96.4213L269.011 96.4206C268.733 95.7889 268.677 95.0723 268.851 94.3226C269.138 93.1814 270.123 91.9825 271.425 90.8458C272.724 89.7117 274.326 88.6519 275.822 87.7866L275.823 87.7863C277.978 86.5248 280.211 85.3568 282.505 84.2911L282.506 84.2906C286.732 82.264 291.092 80.4769 295.534 78.9499L295.535 78.9495C297.922 78.0978 300.34 77.359 302.773 76.7384L302.773 76.7382C304.456 76.3004 306.344 75.9038 308.08 75.7803C309.82 75.6566 311.388 75.8091 312.445 76.4503C313.801 77.2735 314.386 78.6273 314.044 80.1466C313.776 81.3311 312.792 82.5296 311.484 83.6528C310.179 84.7732 308.567 85.8064 307.065 86.6631L307.064 86.6639C304.917 87.9376 302.686 89.1118 300.39 90.1766L300.389 90.1771C296.946 91.8195 293.417 93.3083 289.828 94.6327L289.828 94.6326L289.824 94.634C289.007 94.9691 288.223 95.2901 287.368 95.5158L287.368 95.5154L287.359 95.5184C284.982 96.3712 282.569 97.1006 280.142 97.7002L280.142 97.7002L280.14 97.7007C278.448 98.153 276.563 98.554 274.828 98.6797C273.089 98.8056 271.521 98.6533 270.449 98.0173C269.776 97.6068 269.286 97.0611 269.011 96.4213Z",
    stroke: "url(#paint27_linear_19491_32681)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19491_32681",
    x1: 15,
    y1: 17.1136,
    x2: 323.049,
    y2: 100.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19491_32681",
    x1: 15,
    y1: 9.25002,
    x2: 354.066,
    y2: 109.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19491_32681",
    x1: -4.7111e-7,
    y1: 2.62895,
    x2: 236.647,
    y2: 214.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19491_32681",
    x1: 114.497,
    y1: 152.885,
    x2: 82.7408,
    y2: 17.7214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19491_32681",
    x1: 107.671,
    y1: 146.976,
    x2: 78.8637,
    y2: 24.3651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19491_32681",
    x1: 101.432,
    y1: 141.572,
    x2: 75.3208,
    y2: 30.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19491_32681",
    x1: 94.6066,
    y1: 135.662,
    x2: 71.4445,
    y2: 37.0774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19491_32681",
    x1: 80.9559,
    y1: 123.834,
    x2: 63.692,
    y2: 50.3538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19491_32681",
    x1: 74.1285,
    y1: 117.921,
    x2: 59.8138,
    y2: 56.9936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19491_32681",
    x1: 67.3042,
    y1: 112.009,
    x2: 55.9385,
    y2: 63.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19491_32681",
    x1: 60.4778,
    y1: 106.095,
    x2: 52.0613,
    y2: 70.2719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19491_32681",
    x1: 53.6526,
    y1: 100.181,
    x2: 48.185,
    y2: 76.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_19491_32681",
    x1: -4.7111e-7,
    y1: 1.85,
    x2: 162.715,
    y2: 209.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_19491_32681",
    x1: 270.243,
    y1: -5.81934,
    x2: 270.243,
    y2: 97.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_19491_32681",
    x1: 270.243,
    y1: -5.81934,
    x2: 270.243,
    y2: 97.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_19491_32681",
    x1: 299.252,
    y1: 2.84961,
    x2: 299.252,
    y2: 52.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_19491_32681",
    x1: 299.252,
    y1: 2.84961,
    x2: 299.252,
    y2: 52.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_19491_32681",
    x1: 335.455,
    y1: 92.5759,
    x2: 323.585,
    y2: 59.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_19491_32681",
    x1: 331.942,
    y1: 91.9603,
    x2: 321.1,
    y2: 61.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_19491_32681",
    x1: 328.587,
    y1: 91.3992,
    x2: 318.717,
    y2: 64.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_19491_32681",
    x1: 325.18,
    y1: 90.7226,
    x2: 316.343,
    y2: 66.2837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_19491_32681",
    x1: 321.5,
    y1: 90.342,
    x2: 313.627,
    y2: 68.5688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_19491_32681",
    x1: 318.242,
    y1: 90.0087,
    x2: 311.222,
    y2: 70.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_19491_32681",
    x1: 315.404,
    y1: 89.7131,
    x2: 309.128,
    y2: 72.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_19491_32681",
    x1: 312.986,
    y1: 89.4611,
    x2: 307.343,
    y2: 73.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_19491_32681",
    x1: 310.148,
    y1: 89.1655,
    x2: 305.249,
    y2: 75.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_19491_32681",
    x1: 307.309,
    y1: 88.8709,
    x2: 303.154,
    y2: 77.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_19491_32681",
    x1: 304.311,
    y1: 88.5601,
    x2: 300.941,
    y2: 79.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7675",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19491_32681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthBg);
export default __webpack_public_path__ + "static/media/Mental-health-bg.e47ab2120f747bc0900350c4e752cf83.svg";
export { ForwardRef as ReactComponent };